var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomenav(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    className: "bob-core-components-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icons/_tint/homenav-"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.263 9.595a.516.516 0 0 0-.215.67.47.47 0 0 0 .638.225l1.219-.64v9.775c0 .76.59 1.375 1.314 1.375h4.875v-6.5h3.809V21h4.875c.724 0 1.314-.615 1.314-1.375V9.85l1.214.635a.471.471 0 0 0 .214.055c.176 0 .343-.1.429-.275a.509.509 0 0 0-.214-.67L11.999 4.5 2.263 9.595zM19.14 19.62c0 .21-.162.38-.362.38h-3.923v-6a.49.49 0 0 0-.476-.5h-4.76a.49.49 0 0 0-.477.5v6H5.219c-.2 0-.362-.17-.362-.38V9.345L12 5.61l7.14 3.735V19.62z",
    className: "primarytint"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomenav);
export default __webpack_public_path__ + "static/media/homenav.af743b645e2bcf06cb591260d454f802.svg";
export { ForwardRef as ReactComponent };